/**
 * Route for `advertiser-billing`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserBillingPage } from "../features/advertiser-billing/AdvertiserBillingPage";

export const advertiserBillingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-billing",
	component: AdvertiserBillingPage,
});

export default advertiserBillingRoute;
